import { isUndefined } from "lodash";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (
	item: Order.Model["executingStages"],
	dateFns: DateFns,
) => {
	const timestamp = item?.arrived?.timestamp;

	const content = isUndefined(timestamp)
		? ""
		: dateFns.formatTime2(timestamp, "HH:mm:ss");

	return { content };
};

export default cellProcessing;
